import { render, staticRenderFns } from "./OtherStylistsWithTypeUrl.vue?vue&type=template&id=c44bf4e8"
import script from "./OtherStylistsWithTypeUrl.vue?vue&type=script&lang=js"
export * from "./OtherStylistsWithTypeUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports